import { loader } from "@/helpers/loader";
loader.add()



import './plugins/vue-axios'
import './plugins/v-hotkey'
import './plugins/highcharts'
import './plugins/moment'
import './plugins/vue2-siema'
import './plugins/vue-meta'
import './plugins/i18n'
import './plugins/bootstrap-vue'
import './plugins/notifications'
import './plugins/vue-leader-line'
import './plugins/vue-uuid'
import './plugins/v-mask'
import './components'

import './router/componentHooks'
import App from './App.vue'
import {SERVER_HOST} from '@/config'
import Vue from 'vue'

import router from './router'
import store from '@/store'
import {sync} from 'vuex-router-sync'
import vuetify from './plugins/vuetify'

import i18n from "./helpers/i18n"



// import core styles Vuexy
import './@core/scss/core.scss'
import './@core/assets/fonts/feather/iconfont.css'

import barcode from 'tui-vue-barcode'

import interceptorsSetup from './helpers/interseptors'
interceptorsSetup()

Vue.component('barcode', barcode)

sync(store, router)

Vue.config.productionTip = false

/**
 * Базовый URL сервера
 */
Vue.axios.defaults.baseURL = SERVER_HOST
Vue.axios.defaults.headers.common['Content-Type'] = 'application/json'
Vue.axios.defaults.headers.get['Content-Type'] = 'application/json'



store
  .dispatch('device/initUid')
  .then(() =>
    store
      .dispatch('auth/restoreFromLS')
      .then(({exhibitor, userCompanyId, showId, eventId}) =>
        store
          .dispatch('profile/refresh', {showId, exhibitor, userCompanyId})
          .then(() =>
            store
              .dispatch('event/load', {showId,eventId})
              .then(() =>
                store
                  .dispatch('shards/load', {exhibitor})
                  .then(() => store.dispatch('survey/load', {exhibitor}))
                  .catch(() => {
                  })
              )
              .catch(() => {
              })
          )
          .catch(() => {
          })
      )
      .catch(() => {
      })
      .finally(() => {
        loader.remove()

        new Vue({
          router,
          store,
          vuetify,
          i18n,
          render: (h) => h(App),
        }).$mount('#app')
      })
  )
  .catch(() => {
  })

store.commit('profile/setClientVersion', '1.0')
